import React, { useState, useRef, useEffect } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { DataMap } from '@grapecity/wijmo.grid';
import { FlexGrid, FlexGridColumn, FlexGridCellTemplate } from '@grapecity/wijmo.react.grid';
import GroupIcon from '@mui/icons-material/Group';
import IosShareIcon from '@mui/icons-material/IosShare';

import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { CellType } from '@grapecity/wijmo.grid';

import { useRestApi } from 'context/RestApiContext';

import { MessageModal } from 'components/modal/MessageModal';
import MeetingHistoryQrCodeModal from 'views/ClientCards/MeetingHistoryQrCodeModal';
import { FreeProposalLevels } from 'constants/constants';
import { getFileNameWithoutExt } from 'utils/fileUtils';

import './ClientCard.css';

// 打合せ履歴一覧
const MeetingHistoryList = (props) => {
  const flexGrid = useRef();
  const restApi = useRestApi();

  const freeProposalLevelsMap = new DataMap(FreeProposalLevels, 'key', 'value');

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});

  // 打合せ履歴
  const [meetingHistories, setMeetingHistories] = useState([]);

  // 打合せ履歴QRコードモーダルパラメータ
  const [meetingHistoryQrCodeModalParam, setMeetingHistoryQrCodeModalParam] = useState({});

  useEffect(() => {
    setMeetingHistories(props.meeting_histories ?? []);
  }, [props.meeting_histories]);

  // 共有ボタン押下
  const handleClickShare = () => {
    setMeetingHistoryQrCodeModalParam({
      show: true,
      mode: 'add',
      clientCd: props.clientCd,
      callback: () => {
        props.modalCallback();
      },
    });
  };

  // 追加ボタン押下
  const handleClickAdd = () => {
    props.setMeetingHistoryModalParam({
      show: true,
      mode: 'add',
      clientCd: props.clientCd,
      callback: () => {
        props.modalCallback();
      },
    });
  };

  // 編集ボタン押下
  const handleOnClickEdit = (item) => {
    props.setMeetingHistoryModalParam({
      show: true,
      mode: 'upd',
      clientCd: item.CLIENT_CD,
      meetingHistory: item,
      callback: () => {
        props.modalCallback();
      },
    });
  };

  // PDFを表示
  const handleOnClickPdfFile = (fileNo) => {
    restApi.getToPdf(`/api/meeting_history/pdf/${fileNo}`);
  };

  // 削除ボタン押下
  const handleClickDelete = (item) => {
    setDialog({
      type: `confirm`,
      message: `${item.MEETING_DATE} の打合せ履歴を削除します。よろしいですか？`,
      okCallBack: () => {
        restApi.post(
          `/api/meeting_history/upd`,
          { MEETING_NO: item.MEETING_NO, DEL_FLG: 1 },
          (data) => {
            props.modalCallback();
          }
        );
      },
    });
  };

  return (
    <>
      <Row className="mt-3">
        <Col md="2">
          <div className="description-label">
            <GroupIcon />
            <b>打合せ履歴</b>
          </div>
        </Col>
        <Col md="10" className="text-right">
          <Button
            size="sm"
            style={{ width: '80px', height: '22px' }}
            variant="success"
            className="btn-fill p-0"
            onClick={handleClickShare}
            disabled={meetingHistories.length === 0}
          >
            <IosShareIcon style={{ fontSize: 14 }} />
            共有
          </Button>

          <Button
            size="sm"
            style={{ width: '120px', height: '22px' }}
            variant="primary"
            className="btn-fill p-0 ml-2"
            onClick={handleClickAdd}
          >
            <ControlPointIcon style={{ fontSize: 14 }} />
            打合せ履歴を追加
          </Button>
        </Col>
      </Row>
      <Row className={`mt-0 ${meetingHistories.length === 0 ? 'mb-4' : ''}`}>
        <Col className="table-scroll" style={{ maxBlockSize: '384px' }}>
          {meetingHistories.length === 0 ? (
            <div className="editable-description text-center text-muted" onClick={handleClickAdd}>
              打合せ履歴がありません（クリックで追加）
            </div>
          ) : (
            <FlexGrid
              ref={flexGrid}
              allowSorting={false}
              itemsSource={meetingHistories}
              selectionMode={'Row'}
              headersVisibility={'Column'}
              onDoubleClick={(e) => {
                const grid = flexGrid.current.control;
                const ht = grid.hitTest(e);
                if (ht.cellType === CellType.Cell) {
                  const item = grid.rows[ht.row].dataItem;
                  handleOnClickEdit(item); // 編集ダイアログを開く
                }
              }}
            >
              <FlexGridColumn
                binding="MEETING_DATE"
                header="打合せ日"
                width={88}
                isReadOnly={true}
              ></FlexGridColumn>
              <FlexGridColumn
                binding="MEETING_CONTENT"
                header="打合せ内容"
                width="*"
                isReadOnly={true}
              ></FlexGridColumn>
              <FlexGridColumn
                header="資料"
                binding=""
                isReadOnly={true}
                width={280}
                cssClass="wrap-col"
              >
                <FlexGridCellTemplate
                  cellType="Cell"
                  template={(cell) => (
                    <>
                      {[1, 2, 3, 4, 5].map(
                        (i) =>
                          cell.item[`MOVIE${i}_URL`] && (
                            <a
                              key={`movie-${i}`}
                              href={cell.item[`MOVIE${i}_URL`]}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="mr-2"
                              style={{ textDecoration: 'underline', color: 'blue' }}
                            >
                              {cell.item[`MOVIE${i}_TITLE`]}
                            </a>
                          )
                      )}

                      {[1, 2, 3, 4, 5, 6].map(
                        (i) =>
                          cell.item[`TEMP_${i}_FILE_NAME`] && (
                            <a
                              href="#"
                              className="mr-2"
                              onClick={() => handleOnClickPdfFile(cell.item[`TEMP_${i}_FILE_NO`])}
                              style={{ textDecoration: 'underline', color: 'blue' }}
                            >
                              {getFileNameWithoutExt(cell.item[`TEMP_${i}_FILE_NAME`])}
                            </a>
                          )
                      )}
                    </>
                  )}
                />
              </FlexGridColumn>
              <FlexGridColumn
                header="無料提案残"
                dataMap={freeProposalLevelsMap}
                binding="FREE_FLG"
                isReadOnly={true}
                width={100}
              ></FlexGridColumn>
              <FlexGridColumn header="" binding="" isReadOnly={true} width={28}>
                <FlexGridCellTemplate
                  cellType="Cell"
                  template={(cell) => (
                    <span>
                      <Button
                        className="material-symbols-rounded btn-fill icon-button-sm"
                        variant="primary"
                        title="編集"
                        onClick={() => handleOnClickEdit(cell.item)}
                      >
                        edit
                      </Button>
                    </span>
                  )}
                />
              </FlexGridColumn>

              <FlexGridColumn header="" binding="" isReadOnly={true} width={28}>
                <FlexGridCellTemplate
                  cellType="Cell"
                  template={(cell) => (
                    <Button
                      className="material-symbols-rounded btn-fill icon-button-sm"
                      variant="danger"
                      onClick={() => handleClickDelete(cell.item)}
                    >
                      Delete
                    </Button>
                  )}
                />
              </FlexGridColumn>
            </FlexGrid>
          )}
        </Col>
      </Row>
      {/* メッセージダイアログ */}
      <MessageModal dialog={dialog}></MessageModal>
      <MeetingHistoryQrCodeModal
        params={meetingHistoryQrCodeModalParam}
      ></MeetingHistoryQrCodeModal>
    </>
  );
};

export default MeetingHistoryList;
